module.exports = __webpack_public_path__ + "img/feel-sick.d5a8ee15.jpg";